import ChainsList from '../feature/GsnStatus/ChainsList'

export default function GsnRelaysView () {
  return <ChainsList />
}
